module.exports = __webpack_public_path__ + "static/media/YF06_2.3498f8f7.jpg";